"use client"

import { Icon } from "@chakra-ui/react"
import { HStack } from "@chakra-ui/react/stack"
import { DotFillIcon } from "@/components/icons"

interface AccordionExperienceTimelineProps {
  index: number
}

const AccordionExperienceTimeline = ({
  index,
}: AccordionExperienceTimelineProps) => {
  return (
    <HStack
      _before={{
        bgColor: "border.emphasized",
        content: '""',
        height: "calc(100% + 8px)",
        left: "50%",
        position: "absolute",
        top: index === 0 ? "44px" : 0,
        transform: "translateX(-50%)",
        width: "1px",
        zIndex: 0,
      }}
      className="collumn2"
      flexShrink={0}
      maxWidth="10px"
      minWidth="10px"
      position={"relative"}
      width="10px"
    >
      <Icon
        as={DotFillIcon}
        color="primary.500"
        left={"50%"}
        position={"absolute"}
        top={"40px"}
        transform="translateX(-50%)"
      />
    </HStack>
  )
}

export default AccordionExperienceTimeline
